import { BOOKING_STEPS } from "./constants";
import moment from "moment";

export const getDayName = (dayName, translations) => {
    switch (dayName) {
        case 'Mo':
            return translations.label_monday.substring(0, 3);
        case 'Tu':
            return translations.label_tuesday.substring(0, 3);
        case 'We':
            return translations.label_wednesday.substring(0, 3);
        case 'Th':
            return translations.label_thursday.substring(0, 3);
        case 'Fr':
            return translations.label_friday.substring(0, 3);
        case 'Sa':
            return translations.label_saturday.substring(0, 3);
        case 'Su':
            return translations.label_sunday.substring(0, 3);
        default:
            return ''
    }
}

export const getMonthName = (monthNumber, translations) => {
    switch (monthNumber) {
        case '01':
            return translations.label_january;
        case '02':
            return translations.label_february;
        case '03':
            return translations.label_march;
        case '04':
            return translations.label_april;
        case '05':
            return translations.label_may;
        case '06':
            return translations.label_june;
        case '07':
            return translations.label_july;
        case '08':
            return translations.label_august;
        case '09':
            return translations.label_september;
        case '10':
            return translations.label_october;
        case '11':
            return translations.label_november;
        case '12':
            return translations.label_december;
        default:
            return ''
    }
}

export const parseDateToReadable = (date, translations) => {
    const dateSplit = date.split('-');
    if (dateSplit.length !== 3) return date;
    return dateSplit[2] + ' ' + getMonthName(dateSplit[1], translations);
}

export const getStepTitle = (step, translations, hasSelectedCountry, isRoom) => {
    switch (step) {
        case BOOKING_STEPS.STORE: {
            if (hasSelectedCountry) {
                return translations.label_choose_local;
            } else {
                return translations.label_choose_country;
            }
        }
        case BOOKING_STEPS.PEOPLE: return translations.label_how_much;
        case BOOKING_STEPS.DATE_TIME: return translations.label_choose_time;
        case BOOKING_STEPS.PROMOTION: {
            if (isRoom) {
                return translations.label_choose_room;
            } else {
                return translations.label_choose_menu;
            }
        }
        case BOOKING_STEPS.PERSONAL_DATA: return translations.label_complete_data;
    }
}

export const padNumberLeadingZero = n => String("00" + n).slice(-2);


export const areArraysEqual = (array1, array2) => {
    if (array1.length !== array2.length) return false;
    for (let i = 0; i < array1.length; i++) {
        if (array1[i] !== array2[i]) return false;
    }
    return true;
}

/**
 * Returns the first Monday date after the param "fromDate"
 * @param {Moment} fromDate Date to search searching from
 */
export const searchForMondayFromDate = fromDate => {
    if (!fromDate.isValid()) return;
    let firstMondayDate = fromDate.clone();
    while (true) {
        console.log('Searching');
        if (firstMondayDate.weekday() === 0) return firstMondayDate;

        firstMondayDate = firstMondayDate.clone().add(1, 'day');
    }
}


// WEBPACK FOOTER //
// ./src/utils.js